module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-container"
  }, [_c('EngHeader', {
    attrs: {
      "lost": _vm.lost,
      "data": _vm.data,
      "externalData": _vm.externalData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spaceEng"
  }), _vm._v(" "), (!_vm.win && (_vm.data || _vm.externalData)) ? _c('div', {
    staticClass: "eng-progress-container"
  }, [_c('div', {
    staticClass: "eng-progress-bar",
    attrs: {
      "id": "eng-progress-bar"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.article.length === 0) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("engGame.allEng.loading")) + "\n    "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.win) ? _c('SentanceSummery', {
    attrs: {
      "text": _vm.message,
      "currentData": _vm.data,
      "externalData": _vm.externalData,
      "mistakes": _vm.mistakes
    },
    on: {
      "restartGame": _vm.restartGame
    }
  }) : _vm._e(), _vm._v(" "), (_vm.article && !_vm.win) ? _c('EngGame', {
    attrs: {
      "data": _vm.article[_vm.gameNum],
      "articleId": _vm.articleId,
      "sennum": _vm.gameNum,
      "setFail": _vm.setFail,
      "setWin": _vm.setWin
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ea6490","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EngGame/allEng.vue
// module id = 457
// module chunks = 1 4